<template>
    <div id="store-in">
        <template v-if="showPage==1">
            <div style="width:100%;heigh:100%;">
                <el-card class="table_searchbar">
                    <el-row :gutter="20">
                        <el-col :span='5'>
                            <div @keydown.enter="btnSearch()" class="span_flex">
                                <span class="title">入库单号：</span>
                                <el-select size="small" style="max-width:180px;" v-model="searchForm.stockInId" placeholder="入库单号" @visible-change="closeSelect($event)"  remote :remote-method="(query)=>{this.remoteMethod(query)}" :loading="loading" filterable clearable>
                                    <el-option v-for="item in stockInCodeList" :key="item.stockInId" :label="item.stockInCode" :value="item.stockInId"></el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="" @keydown.enter="btnSearch()">
                                <span class="title">入库类型：</span>
                                <el-select size="small" style="max-width:180px;" v-model="searchForm.stockInType" placeholder="入库类型" filterable clearable>
                                    <el-option v-for="item in stockTypeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="" @keydown.enter="btnSearch()">
                                <span class="title">仓库：</span>
                                <el-select size="small" style="max-width:180px;" v-model="searchForm.warehouseId" placeholder="仓库" clearable>
                                    <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="">
                                <span class="title">申请人：</span>
                                <el-select size="small" style="max-width:180px;" v-model="searchForm.applicantId" placeholder="申请人" filterable clearable>
                                    <el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div style="text-align:right">
                                <a style="margin-right: 12px;cursor: pointer;font-size: 12px;" @click="toggleShowMore">
                                    {{ showMore ? '收起' : '展开' }}
                                    <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                                </a>
                                <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                                <el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                            </div>
                        </el-col>
                    </el-row>
                    <el-collapse-transition>
                        <div v-show="showMore">
                            <el-row :gutter="20">
                                <el-col :span="10">
                                    <div class="" @keydown.enter="btnSearch()">
                                        <span class="title">入库时间：</span>
                                        <el-date-picker class="y_records_width" style="width:533px !important" v-model="searchForm.storeTime" type="daterange" range-separator="-" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-collapse-transition>
                </el-card>
                <el-card class="table-card">
                    <div class="table_common_operbar" v-if="permission.btn_stockIn_apply">
                        <el-row>
                            <el-button icon="el-icon-plus" type="primary" size="small" @click="addWindowShow()">新增入库</el-button>
                        </el-row>
                    </div>
                    <el-table @sort-change='sortChangeEvent' :default-sort='defaultSort' :data="tableData" style="width: 100%" class="deviceTable" :row-style="showHighlight">
                        <el-table-column prop="stockInCode" label="入库单号" min-width="130"></el-table-column>
                        <el-table-column prop="stockInType" :formatter="parseStockInType" label="入库类型" sortable="custom"  min-width="100"></el-table-column>
                        <el-table-column prop="warehouseName" sortable="custom" label='仓库' min-width="110"></el-table-column>
                        <el-table-column prop="stockInTime" sortable="custom" label='入库时间' min-width="120"></el-table-column>
                        <el-table-column label='状态' min-width="110">
                            <template slot-scope="scope">
                                <span :style="{color:parseStyle(scope.row)}">{{parseStatus(scope.row)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="applicantName" sortable="custom" label='申请人' min-width="100"></el-table-column>
                        <el-table-column prop="auditUserName" sortable="custom" label='审核人' min-width="100"></el-table-column>
                        <el-table-column sortable="custom" prop="gmtAudit" label='审核时间'  min-width="120" show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作" fixed="right" width="160">
                            <template slot-scope="scope">
                                <el-button type="text" v-if="permission.btn_stockIn_get" @click="showViewDialog(scope.row)" size="small">查看</el-button>
                                <el-button v-if="permission.btn_stockIn_update&&scope.row.auditStatus==0" type="text" @click="showEditPage(scope.row)" size="small">编辑</el-button>
                                <el-button v-if="permission.btn_stockIn_audit&&scope.row.auditStatus==0" type="text" @click="showEditDialog(scope.row)" size="small">审核</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page" v-if="tableData.length > 0">
                        <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
                        <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
                            <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"></el-pagination>
                        </div>
                    </div>
                </el-card>
                <!-- 查看入库详情开始 -->
                <el-dialog title="查看入库记录" @close="cancelViewDialog" :visible.sync="viewDialogVisible" :width="span==5?'55%':'77%'" center :close-on-click-modal="false">
                    <el-row style="margin-top:20px">
                        <el-col :span='6'>
                            <div class="">
                                <span class="title">入库单号：</span>
                                <span class="value">{{info.stockInCode}}</span>
                            </div>
                        </el-col>

                        <el-col :span='6'>
                            <div class="">
                                <span class="title">入库类型：</span>
                                <span class="value">{{info.stockInTypeTxt}}</span>
                            </div>
                        </el-col>
                        
                        <el-col :span='6'>
                            <div class="">
                                <span class="title">入库时间：</span>
                                <span class="value">{{info.stockInTime}}</span>                   
                            </div>
                        </el-col>

                        <el-col :span="6">
                            <div class="">
                                <span class="title">仓库：</span>
                                <span class="value">{{info.warehouseName}}</span> 
                                
                            </div>
                        </el-col>
                        
                    </el-row>
                    <el-row style="margin-top:20px;">
                        <el-col :span="6">
                            <div class="">
                                <span class="title">库位：</span>
                                <span class="value">{{info.factoryName}}</span> 
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title">申请人：</span>
                                <span class="value">{{info.applicantName}}</span> 
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title">审核人：</span>
                                <span class="value">{{info.auditUserName}}</span> 
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title">状态：</span>
                                <span class="value">{{parseStatus(info)}}</span> 
                            </div>
                        </el-col>
                        
                    </el-row>
                    <el-table :data="stockInDetailList" stripe style="width: 100%">
                        <el-table-column prop="productionBatchCode" label="批次号" min-width="110"></el-table-column>
                        <el-table-column prop="materialCode" label="物料编码" min-width="110"></el-table-column>
                        <el-table-column prop="materialName" label="物料名称" min-width="110"></el-table-column>
                        <el-table-column prop="specification" label="规格" min-width="110"></el-table-column>
                        <el-table-column prop="amount" label="入库数量" min-width="110"></el-table-column>
                        <el-table-column prop="unitOfQuantity" label="入库单位" min-width="110"></el-table-column>
                    </el-table>
                    
                    <el-row style="margin-top:20px;">
                        <el-col :span="24">
                            <div class="">
                                <span class="title">审核备注：</span>
                                <span class="value">{{info.auditRemark}}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="cancelViewDialog" type="primary">确 定</el-button>
                    </span>
                </el-dialog>
                <!-- 新增入库详情结束 -->

                <!-- 审核开始 -->
                <el-dialog title="入库审核" @close="cancelEditDialog" :visible.sync="editDialogVisible" :width="span==5?'25%':'40%'" center :close-on-click-modal="false">
                    <el-row>
                        <span>备注</span>
                        <el-input type="textarea" v-model="editRemark" maxlength="255" :show-word-limit='true' :rows="3"></el-input>
                    </el-row>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="submitEditDialog(1)" type="primary">通 过</el-button>
                        <el-button @click="submitEditDialog(2)" type="danger">不通过</el-button>
                        <el-button @click="cancelEditDialog">取 消</el-button>
                    </span>
                </el-dialog>
                <!-- 审核结束 -->
            </div>
        </template>
        <template v-if="showPage==2">
            <StockInDetail></StockInDetail>
        </template>
        <template v-if="showPage==3">
            <StockInEdit :selectedInfo="selectedInfo"></StockInEdit>
        </template>
    </div>
</template>

<script>
import StockInDetail from './StockInDetail'
import StockInEdit from './StockInEdit'

export default {
    name: 'RecordsOfStoreEnter',
    components: {
        StockInDetail,
        StockInEdit
    },
    data() {
        return {
            showMore:false,
			stockInCodeList:[],
			stockTypeOption:[// 1生产 3采购 4直接
                {label:'生产入库',value:1},
                {label:'盘点入库',value:2},
				{label:'采购入库',value:3},
				{label:'直接入库',value:4},
			],
			warehouseList:[],
			loading:false,
            orderType: 'DESC',//排序类型
            orderColumn: 'gmtCreate',//排序列
            defaultSort: { prop: 'gmtCreate', order: 'descending' },//默认排序设置
            fristLoad: false,
            editRemark: null,
			selectRow: {},
            statusOption: [
                { id: 0, label: '待审核', value: 0 },
                { id: 1, label: '通过审核', value: 1 },
                { id: 2, label: '未通过审核', value: 2 },
            ],
            info:{},
            userList: [],
            selectedInfo: null,
            stockInDetailList: [],
            showPage: 1,
            levelOption: [],
            W: false,
            btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
            searchFormTemp: '',//临时搜索数据
            searchForm: {
				storeTime:[],
				stockInType:null,
				warehouseId:null,
				applicantId:null,
                stockInId: null,
            },
            addForm: {
                itemType: null,
                materialCode: '',
                specification: '',
                materialName: '',
                unitTypeId: null,
                stockInCode: null
            },
            tableData: [],
            tableCurrentPage: 1,
            tableTotalPage: 2,
            addDialogVisible: false,
            editDialogVisible: false,
            viewDialogVisible: false,
            data: {
                token: localStorage.getItem("token"),
            },
            loginUser: '',
            permission: JSON.parse(localStorage.getItem("permission"))
        }
    },
    mounted: function () {
        this.initTable();
		this.loadUlserList()
		this.loadStockInCodeList()
		this.loadTreeList()
        this.loginUser = window.localStorage.getItem('username')
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
        }
    },
    computed: {
        span() {
            return this.W ? 5 : 6
        }
    },
    deactivated: function () {
        console.log("deactivated");
    },
    methods: {
        toggleShowMore(){
            this.showMore = ! this.showMore
        },
		async loadStockInCodeList(stockInCode) {
            let {data} = await this.$RequestUtil.getAsync({ url: '/api/select/stockInCodeSelect',  params: { stockInCode }, })
            this.stockInCodeList = data
		},

		async remoteMethod(query){
			this.loading = true
			await this.loadStockInCodeList(query)
			this.loading=false
		},

		async closeSelect(ev){
			if(!ev){
				await this.loadStockInCodeList()
			}
		},

		async loadTreeList(id){
			let res = await this.$RequestUtil.getAsync({url: '/api/select/listDefaultMaterialFactoryModel',params: {id}})
			this.warehouseList = res.data
		},

        showHighlight(scope) {
            if (scope.row.hasDeletedUser == 1) {
                return { background: '#FFFFCC' }
            }
		},
		
        testNum(ev) {
            this.isSumbit = true
            let n = Number(ev)
		},
		
        sortChangeEvent(param) {
            let orderType = param.order;
            let orderColumn = param.prop;
            this.orderColumn = orderColumn;
            if (orderType == 'descending') {
                this.orderType = 'DESC';
            } else if (orderType == 'ascending') {
                this.orderType = 'ASC';
            } else {
                this.orderType = orderType;
                this.orderColumn = null
            }
            this.search(this.tableCurrentPage);
		},
		
        reload() {
            this.initTable();
           
            this.loadUlserList()
		},
		
		
        loadUlserList() {
            this.$RequestUtil.get({
                url: '/api/select/listWorker',
                params: { noFilterDeparture: 1 },
                type: 'sync',
                success: (res) => {
                    if (res.code == 0) {
                        this.userList = res.data;
                        
                    }
                }
            });
		},
		
        async showEditPage(rowData) {
            let data = await this.loadStockInDetail(rowData.stockInId)
            this.selectedInfo = {
                stockInId: rowData.stockInId,
                stockInType:rowData.stockInType,
                warehouseId:rowData.warehouseId,
                factoryId:rowData.factoryId,
                stockInTime:rowData.stockInTime,
                stockInCode:rowData.stockInCode,
                applicantId:rowData.applicantId,
				data
            }
            this.showPage = 3
        },
      
        async loadStockInDetail(stockInId) {
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({ url: '/api/stock/stockIn/getDetail', type: 'sync', params: { stockInId }, })
            return data
		},
		
        
		
        cancelEditDialog() {
            this.editDialogVisible = false
            this.addForm = {
                itemType: null,
                materialCode: '',
                specification: '',
                materialName: '',
                unitTypeId: null,
                stockInCode: null,
                id: null,
                amount: null,
                gmtCreate: null,
                productionBatch: null,
                name: null,
            }
            this.editRemark = null
		},
		
        cancelViewDialog() {
            this.viewDialogVisible = false
            this.selectRow = {}
		},
		
      
		
    
		
        submitEditDialog(type) {
            this.$RequestUtil.post({
                url: '/api/stock/handleApplication/stockIn',
                type: 'sync',
                params: {
                    stockInId: this.selectRow.stockInId,
                    auditStatus: type,
                    auditRemark: this.editRemark
                },
                success: (res) => {
                    if (res.code == 0) {
                        if (type == 1) {
                            this.$message.success('审核成功')
                        } else {
                            this.$message.success('提交成功')
                        }
                        this.initTable();
                        this.cancelEditDialog()
                    } else {
                        this.$message.error(res.message);
                    }
                },
            })

		},
		
        btnSearch: function () {
            this.tableCurrentPage = 1;
            this.btnPressType = 1
            this.search();
		},
		
        clearSearch() {
            let form = this.searchForm;
			this.btnPressType = 2;
			form.storeTime=[]
			form.stockInType=null
			form.warehouseId=null
			form.applicantId=null
			form.stockInId=null
		},
		
        search: function () {
            let temp;
            switch (this.btnPressType) {
                case 1:
                    temp = commonUtils.cloneObj(this.searchForm);
                    this.searchFormTemp = commonUtils.cloneObj(temp);
                    break;
                case 0:
                    temp = {
                        storeTime:[],
						stockInType:null,
						warehouseId:null,
						applicantId:null,
						stockInId: null,
                    };
                    break;
                case 2:
                    temp = this.searchFormTemp;
                    break;
                case 3:
                    temp = this.searchFormTemp;
                    break;
			}
			let storeStartTime,storeEndTime;
			if(temp.storeTime&&temp.storeTime.length==2){
				storeStartTime = temp.storeTime[0]
				storeEndTime = temp.storeTime[1]
			}
            this.$RequestUtil.get({
                url: '/api/stock/listStockIn',
                type: 'sync',
                params: {
                    pageNum: this.tableCurrentPage,
                    pageSize: 10,
                    stockInType: temp.stockInType,
                    stockInType: temp.stockInType,
                    applicantId: temp.applicantId,
					stockInId: temp.stockInId,
					warehouseId:temp.warehouseId,
					storeStartTime,
					storeEndTime,
                    stockInCode: temp.stockInCode,
                    orderColumn: this.orderColumn,
                    orderType: this.orderType
                },
                success: (res) => {
                    if (res.msg == this.$Global.RESPONSE.SUCCESS) {
                        this.tableData = res.data;
                        this.tableTotalPage = res.totalPages;
                        if (res.totalPages == 0 && this.fristLoad) {
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            });
		},
		
        pageChange: function (targetPage) {
            this.tableCurrentPage = targetPage;
            this.btnPressType = 3;
            this.search();
		},
		
        initTable: function () {
            this.search();
		},
		
        addWindowShow: function () {
            // this.addDialogVisible = true;
            this.showPage = 2

		},
		
        showEditDialog: function (rowData) {
            this.addForm.id = rowData.id
            this.selectRow = rowData
            this.editDialogVisible = true
            
		},
		
        async showViewDialog(rowData) {
            this.stockInDetailList =  await this.loadStockInDetail(rowData.stockInId)
            this.info = rowData
            this.info.stockInTypeTxt = this.parseStockInType(rowData)
            this.viewDialogVisible = true;
            this.selectRow = rowData

        },
        parseDate: function (rowData) {
            if (rowData.gmtCreate != null) {
                let dateString = commonUtils.timestampToDate(rowData.gmtCreate);
                return dateString;
            }
		},
		
        parseType(rowData) {
            if (rowData.itemType != null) {
                if (rowData.itemType == 0) {
                    return '产品'
                } else if (rowData.itemType == 1) {
                    return '零件'
                } else if (rowData.itemType == 2) {
                    return '原材料'
                }
            }
		},
		
        parseStyle(rowData) {
            if (rowData.auditStatus != null) {
                if (rowData.auditStatus == 1) {
                    return '#2FD859'
                } else if (rowData.auditStatus == 2) {
                    return 'red'
                }
            }
		},
		
        parseStatus(rowData) { // 0-待审核；1-审核通过；2-审核
            if (rowData.auditStatus != null) {

                if (rowData.auditStatus == 0) {
                    return '待审核'
                } else if (rowData.auditStatus == 1) {
                    return '通过审核'
                } else if (rowData.auditStatus == 2) {
                    return '未通过审核'
                }
            }
		},
		
        parseWarehoseName(rowData) {
            let str = ''
            this.tree.forEach(item => {
                if (item.id == rowData.topWarehouseId) {
                    str = item.warehouseName
                }
            })
            return str
		},
		
        parseAuditData(rowData) {
            if (rowData.gmtAudit != null) {
                let dateString = commonUtils.timestampToDate(rowData.gmtAudit);
                return dateString;
            }
		},
		
        parseStockInTime(rowData) {
            if (rowData.timeOfStockIn != null) {
                let dateString = commonUtils.timestampToDate(rowData.timeOfStockIn);
                return dateString;
            }
		},
		
        parseStockInType(rowData) {
            return (this.stockTypeOption.find(item=>item.value==rowData.stockInType)||{}).label
        }
    }
}
</script>

<style scoped>
.table_searchbar .title11 {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}

.add_form .title {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    display: inline-block;
    text-align: right;
    width: 70px;
}

.add_form .value {
    display: inline-block;
}

.el-row {
    margin-bottom: 20px;

    & :last-child {
        margin-bottom: 0;
    }
}



.import_upload {
    display: inline;
}

.page {
    display: flex;
    justify-content: flex-end;
}

@media screen and (max-width: 1450px) {
    .page {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 30px;
    }
}

.total_page {
    margin-top: 20px;
    margin-right: 26px;
    color: #606266;
    font-size: 14px;
}
</style>
<style>
.table_searchbar .el-button--mini,
.el-button--mini.is-round {
    padding: 7px 10px;
}

@media screen and (max-width: 1366px) {
    #store-in .el-date-editor.el-input,
    #store-in .el-date-editor.el-input__inner {
        width: 176px !important;
    }
}

@media screen and (min-width: 1400px) and (max-width: 1920px) {
    .y_records_width {
        width: 220px !important;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/stock/RecordsOfStoreEnter.vue